import axios from '@fs/zion-axios'

const serviceBaseUrl = '/service/rootstech/rtc2021/orchestration'

// Expecting:
// {
//   "cisUserId" : "...",
//   "language" : "...",
//   "firstName" : "...",
//   "lastName" : "...",
//   "emailAddress" : "...",
//   "optInEmail" : true,
//   "mobileCountry" : "...",
//   "mobileNumber" : "...",
//   "optInMobile" : true,
// }
export const saveSubscription = (data) => {
  return axios.post(`${serviceBaseUrl}/subscriptions/updates`, data)
}

export const dummy = () => {}
